import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';
import { reduxForm } from 'redux-form'
import { withRouter } from 'react-router-dom'
import ForgotPasswordForm from '../components/forgotPasswordForm/ForgotPasswordForm';
import {requestResetPassword, clearResetPassword} from '../store/actions/resetPassword';

const mapStateToProps = (state) => {
    return {
        forgotPassword: state.forgotPassword
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onSubmit: (data) => {
            dispatch(requestResetPassword(data.email)).then(d=>{
                ownProps.history.push(`/login`)
            }).catch( e => {})
        },
        clearResetPassword: () => {
            dispatch(clearResetPassword())
        }
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.clearResetPassword();
    }
};

const formProps = {
    form: 'forgot'
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    reduxForm(formProps),
)(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordFormContainer.js